
import React from 'react'


function QuerySpacer({type, xy, onClick}) {
    return (
        <div className={"query-spacer "+type}
             onClick={(e)=>{e.preventDefault(); onClick(xy, type); }} />
    );
}

export default QuerySpacer;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/QuerySpacer.js